import { AxiosRequestConfig, AxiosResponse } from "axios";
import axiosInstance from "./interceptor";

/**
 * Appends a unique query param on blob GETs so browsers do not return disk-cached
 */
function withBlobCacheBust(config: AxiosRequestConfig): AxiosRequestConfig {
  if (config.responseType !== "blob") {
    return config;
  }
  const existing = config.params;
  if (existing instanceof URLSearchParams) {
    const params = new URLSearchParams(existing.toString());
    params.set("_", String(Date.now()));
    return { ...config, params };
  }
  return {
    ...config,
    params: { ...(existing as Record<string, unknown> | undefined), _: Date.now() },
  };
}

export function getRequest<T>(URL: string, config: AxiosRequestConfig = {}): Promise<AxiosResponse<T>> {
  const withTimeout = URL.includes("/analytics/list-by-provider/quoting-performance")
    ? { ...config, timeout: 120_000 }
    : config;
  const finalConfig = withBlobCacheBust(withTimeout);
  return axiosInstance.get<T>(`${URL}`, finalConfig).then((response) => response);
}

export function postRequest<T>(
  URL: string,
  payload: Record<string, any>,
  config: AxiosRequestConfig = {},
): Promise<AxiosResponse<T>> {
  return axiosInstance.post<T>(`${URL}`, payload, config).then((response) => response);
}

export function putRequest<T>(
  URL: string,
  payload: Record<string, any>,
  config: AxiosRequestConfig = {},
): Promise<AxiosResponse<T>> {
  return axiosInstance.put<T>(`${URL}`, payload, config).then((response) => response);
}

export function patchRequest<T>(
  URL: string,
  payload: Record<string, unknown>,
  config: AxiosRequestConfig = {},
): Promise<AxiosResponse<T>> {
  return axiosInstance.patch<T>(`${URL}`, payload, config).then((response) => response);
}

export function deleteRequest<T>(URL: string, config: AxiosRequestConfig = {}): Promise<AxiosResponse<T>> {
  return axiosInstance.delete<T>(`${URL}`, config).then((response) => response);
}
